import { useMemo } from "react";

export const useAlignment = (alignment: string, S: { [key: string]: string }) => {
    const alignmentClass = useMemo(() => {
        switch (alignment) {
            case "ALIGNMENT_CENTER":
                return S.alignmentCenter;
        }
    }, [alignment, S]);

    const isAlignmentCenter = useMemo(() => {
        return alignment === "ALIGNMENT_CENTER";
    }, [alignment]);

    return {
        alignmentClass,
        isAlignmentCenter,
    };
};
